import * as React from "react";
import { Checkbox, DefaultButton, Dialog, DialogFooter, PrimaryButton, Spinner, TextField } from "office-ui-fabric-react";
import { useState } from "react";
import { IRole, IUserWithPhoto } from "../../../types/User.types";
import { getRoles, saveRoles } from "../../../api/userInfo";
import { ICheckboxStyles } from "@fluentui/react";

export interface ICancelReasonDialogProps {
    onDismiss: (cancel: boolean, cancelReason: string | undefined) => void;
}

export const CancelReasonDialog = (props: ICancelReasonDialogProps) => {
    const [ loading, setLoading ] = useState(true);
    const [ cancelReason, setCancelReason ] = useState<string>();

    React.useEffect(() => {
        setLoading(false);
    });    

    return (
        <Dialog isOpen={true} dialogContentProps={{
            title: "Cancellation Reason"
        }}>
            { loading === false && (
                <TextField multiline label="Reason" value={cancelReason} onChange={(e, newValue) => {
                    setCancelReason(newValue);
                }} />
            )}
            <DialogFooter>
                <PrimaryButton disabled={cancelReason == undefined || cancelReason == ""} label="Save" iconProps={{iconName: "Save"}} onClick={() => {
                    props.onDismiss(true,cancelReason);
                }} />
                <DefaultButton label="Cancel" iconProps={{iconName: "Cancel"}} onClick={() => {
                    props.onDismiss(false,"");
                }} />
            </DialogFooter>
        </Dialog>
    )
};
